<template>
  <div
    id="branding-template-edit"
  >
    <branding-nav />
    <branding-template-form />
  </div>
</template>
<script>
import BrandingTemplateForm from '@/components/BrandingTemplateForm'
import BrandingNav from '@/components/BrandingNav'

export default {
  components: {
    'branding-nav': BrandingNav,
    'branding-template-form': BrandingTemplateForm
  }
}
</script>




// WEBPACK FOOTER //
// src/components/BrandingTemplateCreate.vue